export const tools = [
  {
    category: 'AI 工具',
    color: '#1976d2',
    items: [
      {
        name: '腾讯混元 3D',
        description: '图或文生 3D 模型',
        url: 'https://3d.hunyuan.tencent.com/',
      },
      {
        name: 'tripo3d.ai',
        description: '图或文生 3D 模型',
        url: 'https://www.tripo3d.ai/',
      },
      {
        name: 'Deepseek',
        description: 'Deepseek 官网',
        url: 'https://www.deepseek.com/',
      },
      {
        name: 'ChatGPT',
        description: 'ChatGPT 官网',
        url: 'https://chat.openai.com/',
      },
      {
        name: '腾讯元宝+Deepseek',
        description: '腾讯元宝',
        url: 'https://yuanbao.tencent.com/',
      },
      {
        name: 'AI 工具汇总',
        description: 'AI、创意和艺术领域的精选合集，来自 Latent Cat',
        url: 'https://latentbox.com/zh',
      },
      {
        name: 'Meta AI Demos',
        description: '探索人工智能的未来可能性尝试采用 Meta 最新人工智能研究成果的实验演示。',
        url: 'https://aidemos.meta.com/',
      },
      {
        name: 'Deepseek Janus-Pro',
        description: 'Deepseek Janus-Pro-7b 演示地址',
        url: 'https://huggingface.co/spaces/deepseek-ai/Janus-Pro-7B',
      },
    ]
  },
  {
    category: '游戏资源',
    color: '#2e7d32',
    items: [
      {
        name: 'itch.io',
        description: '免费游戏资源网站',
        url: 'https://itch.io/',
      },
      {
        name: 'Mixamo',
        description: '为游戏、电影等制作 3D 角色动画',
        url: 'https://www.mixamo.com/',
      },
      {
        name: 'Iconify',
        description: '免费图标库',
        url: 'https://icon-sets.iconify.design/',
      },
      {
        name: 'Material Icons',
        description: '免费图标库',
        url: 'https://fonts.google.com/',
      },
      {
        name: 'Animated Drawings',
        description: '2D 图片转动画',
        url: 'https://sketch.metademolab.com/',
      },
    ]
  },
  {
    category: '演示页面',
    color: '#ed6c02',
    items: [
      {
        name: '小游戏演示页面',
        description: '包含了一些h5小游戏的演示页面',
        url: 'https://tggames.noyagames.com/',
      },
    ]
  },
  {
    category: '开发工具',
    color: '#9c27b0',
    items: [
      {
        name: 'Image_Translation',
        description: '在线图片翻译',
        url: 'https://cn.jollytoday.com/Image_Translation/',
      },
      {
        name: 'OCRmyPDF',
        description: 'OCRmyPDF 是一个用于将 PDF 文件转换为可编辑文本的工具',
        url: 'https://github.com/ocrmypdf/OCRmyPDF?tab=readme-ov-file',
      },
      {
        name: 'Unicode code converter',
        description: 'Unicode 转换工具',
        url: 'https://r12a.github.io/app-conversion/',
      },
      {
        name: '随机密码',
        description: '生成随机密码',
        url: 'https://www.suijimimashengcheng.bmcx.com/',
      },
      {
        name: '在线时间戳',
        description: '时间戳转换',
        url: 'https://tool.lu/timestamp/',
      },
      {
        name: 'Aconvert',
        description: '万物可转换',
        url: 'https://www.aconvert.com/',
      },
      {
        name: 'Itdog',
        description: '网络工具',
        url: 'https://www.itdog.cn/',
      },
      {
        name: 'HTML颜色代码',
        description: '颜色工具',
        url: 'https://htmlcolorcodes.com/',
      },
    ]
  }
];